/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface PlaybackPaywallUiModuleBody
 */
export interface PlaybackPaywallUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    moduleType: PlaybackPaywallUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof PlaybackPaywallUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof PlaybackPaywallUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof PlaybackPaywallUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof PlaybackPaywallUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    postTrailerPrimaryText: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    postTrailerPrimaryCta: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    postTrailerSecondaryCtaAuth?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    postTrailerSecondaryCtaAnon?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    postEpisodePrimaryCta: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    postEpisodeSecondaryCtaAuth?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackPaywallUiModuleBody
     */
    postEpisodeSecondaryCtaAnon?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PlaybackPaywallUiModuleBodyModuleTypeEnum {
    PLAYBACK_PAYWALL = 'PLAYBACK_PAYWALL'
}



